const
    $KEY_ELEMENT = document.querySelector('script[type="text/google-maps-api-key"]'),
    API_KEY = $KEY_ELEMENT ? $KEY_ELEMENT.innerText : process.env.GOOGLE_MAPS_API_KEY,
    DEFAULT_LOCATION = {lat: -34.9285873, lng: 138.6006675},
    nget = require('./nget')
;

let apiImported = false, apiImporting = false, geocoder;

let pendingInsertions = [];

if (!API_KEY) {
    throw 'GMaps API key was not found...';
}

function _setupMapContainer($container, mapStyles = {}) {
    return new Promise((resolve, reject) => {
        const $element = document.createElement('div'),
            $map = document.createElement('div')
        ;

        for (let [property, value] of Object.entries(mapStyles)) {
            $map.style[property] = value;
        }

        $container.appendChild($element);
        $map.setAttribute('id', `map-${(new Date).getTime()}`);
        $map.setAttribute('class', 'google-map');
        $element.appendChild($map);

        resolve($map);
    });
}

function _instantiateGoogleMaps($mapElement, mapInitOptions = {}) {

    return new Promise((resolve, reject) => {
        if (!google || !nget(['maps', 'Map'], google) || !nget(['maps', 'Geocoder'], google)) {
            throw 'Google Maps API did not appear to load correctly?';
        }

        const initOptions = mapInitOptions || {
            center: DEFAULT_LOCATION,
            zoom: 17
        };

        map = new google.maps.Map($mapElement, initOptions);

        map.$mapElement = $mapElement;
        $mapElement._map = map;

        if (!geocoder) {
            geocoder = new google.maps.Geocoder();
        }

        resolve(map);
    });
}


//@todo Add support for stacking pending calls if maps is already trying to import (only important if we use multiple maps in a page...)
function _assertExternalApi(libraries = []) {
    return new Promise(((resolve, reject) => {
        if (apiImported) {
            resolve();
            return;
        }

        if (apiImporting) {
            pendingInsertions.push(resolve);
            return;
        }
        else {
            apiImporting = true;
            const $script = document.createElement('script');
            $script.setAttribute('async', '');
            $script.setAttribute('defer', '');
            $script.addEventListener('load', () => {
                apiImported = true;
                apiImporting = false;
                //run any pending resolutions
                for (let r of pendingInsertions) {
                    r();
                }
                resolve();
            });

            let url = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}`;

            if (libraries && libraries.length > 0) {
                url += '&libraries=' + libraries.join(',');
            }

            $script.setAttribute('src', url);
            document.querySelector('body').appendChild($script);
        }
    }));
}

function insertMap($targetElement, mapInitOptions = {}, mapStyles = {}, libraries = []) {

    // This is where the google maps increases the cost.

    return new Promise(((resolve, reject) => {
        _assertExternalApi(libraries)
            .then(() => {
                return _setupMapContainer($targetElement, mapStyles);
            }, () => {
                throw 'Error asserting external API...'
            })
            .then($mapElement => {
                return _instantiateGoogleMaps($mapElement, mapInitOptions)
            }, null)
            .then(resolve, reject);
    }));
}

module.exports = {
    insertMap,
    geocoder: () => geocoder
};
